export const FEEDBACK_FACES = {
  1: 'angry-face',
  2: 'sad-face',
  3: 'neutral-face',
  4: 'happy-face',
  5: 'laughing-face'
};